module.exports = __webpack_public_path__ + "static/media/loading.cbee4f42.gif";